export default [
  {
    title: 'Sobre a NoVerde',
    text: `A NoVerde é uma empresa de tecnologia, com foco na geração de valor através de experiências inovadoras. Desde 2016 estão construindo uma comunidade de brasileiros que contam com um serviço de crédito inteligente para encarar seus diversos desafios financeiros. São 100% digitais. Através de um aplicativo, disponibiliza opções de crédito inteligente na palma da mão de milhares de brasileiros.`,
  },
  {
    title: 'O que é empréstimo sem garantia?',
    text: `
      A principal característica do empréstimo pessoal sem garantia é não exigir que você coloque seus bens (ou seu salário) no contrato de aquisição como forma de assegurar o pagamento.
      <br />
      Caso você fique inadimplente, a instituição financeira tomará as medidas cabíveis, como negativação do CPF e tentativas de renegociação.
      <br />
      Mas, como o empréstimo não tem garantia, as taxas geralmente são mais altas em relação ao empréstimo com garantia (quando você inclui seus bens para assegurar o pagamento).
      <br />
      De maneira geral, ainda apresenta taxas de juros mais baixas e prazos maiores de pagamento em relação a outras modalidades de crédito, como cartão de crédito e cheque especial, por exemplo.
    `,
  },
  {
    title: 'O que é oferta pré-aprovada?',
    text: `Isso significa que o seu empréstimo está quase lá: as instituições parceiras fizeram uma análise rápida da sua situação financeira e você se enquadra nas condições estabelecidas para conseguir o crédito. Mesmo assim, sua solicitação final de empréstimo ainda passará por análise completa antes de ser aprovada.`,
  },
  {
    title: 'Pode mudar as condições da oferta?',
    text: `
      Antes de continuar com a oferta pré-aprovada. Você pode tentar uma nova simulação, editando o valor do empréstimo e a quantidade de parcelas para pagar. Vale lembrar que os valores podem mudar devido à análise feita no momento.
      <br />
      As taxas de juros são personalizadas conforme o seu perfil de crédito e as regras de cada instituição. Sendo assim, não podemos modificar.
      <br />
      Após continuar com a oferta na Juros Baixos, será possível mudar as condições da oferta somente depois de 5 dias.
      <br />
      Caso o contrato já esteja assinado, essas alterações não podem ser feitas, pois o contrato já foi aceito nas condições que foram estipuladas.
    `,
  },
  {
    title: 'Quais são as etapas de solicitação?',
    text: `
      Após continuar com a oferta pré-aprovada na Juros Baixos, você será redirecionado para acessar o site da NoVerde e finalizar a sua contratação.
      <br />
      Após acessar o site, basta ‘Entrar’ com seu ‘CPF’. Caso ainda não tenha uma conta, clique em ‘Esqueci minha senha’, informe o seu ‘CPF’ e ‘Data de nascimento’. Então a NoVerde enviará um código de redefinição para o seu e-mail ou telefone de cadastro, atualize e tente novamente realizar o acesso novamente.
      <br />
      Quando acessar o seu pré-cadastro pelo site, finalize a sua solicitação preenchendo seus dados pessoais e dados bancários.
    `,
  },
  {
    title: 'Quem pode contratar o empréstimo?',
    text: `
      Para considerar quem pode contratar um empréstimo, as instituições financeiras fazem análises que avaliam o score, histórico de crédito e a renda da pessoa física para validar a oferta de empréstimo.
      <br />
      Se você recebeu uma oferta pré-aprovada, isso significa que você está mais perto de conseguir o empréstimo. Agora basta apenas continuar com a oferta pré-aprovada e finalizar a sua solicitação para verificar se é aprovado.
      <br />
      É importante saber que não é permitido usar dados de outra pessoa para solicitar o empréstimo. Caso haja alguma divergência de dados (CPF diferente ou conta bancária cujo titular não seja você), a sua proposta é automaticamente negada.
    `,
  },
  {
    title: 'Precisa fazer depósito para liberar o empréstimo?',
    text: `
      Não é permitido cobrar um valor antecipado para depositar o valor do empréstimo na sua conta em nenhuma instituição financeira. Isso é golpe!
      <br />
      Caso tenha recebido algum contato suspeito em nome da NoVerde sobre isso, entre em contato com o nosso atendimento.
      <br />
      Caiu em um golpe? Ajude outras pessoas fazendo uma denúncia na Delegacia da Polícia Civil mais próxima de você.
    `,
  },
  {
    title: 'Qual o tipo de conta bancária aceitam?',
    text: `
      A NoVerde aceita Conta Corrente e Poupança de pessoa física, que seja vinculada ao seu CPF e aptas a receber TED. Eles não aceitam conta salário ou de pessoa jurídica.
      <br />
      As contas corrente e contas de poupança podem ser abertas diretamente nas agências bancárias ou correspondentes bancários (como em lotéricas, por exemplo).
      <br />
      Importante! A NoVerde só faz transferência na conta da pessoa solicitante do empréstimo (mesmo CPF), caso isso não ocorra o empréstimo será cancelado.
    `,
  },
  {
    title: 'Como saber o andamento da minha proposta?',
    text: `
      Depois do envio dos documentos pelo aplicativo ou pelo site da NoVerde, você tem um dia útil (dia útil é qualquer dia que não seja sábado, domingo ou feriado) para analisar a sua proposta. Na tela do seu aplicativo e na tela do site, mostrará o status da solicitação e previsão da conclusão.
      <br />
      Assim que a proposta for analisada, você será comunicado por e-mail e também pelo aplicativo da NoVerde.
      <br />
      Caso o fluxo de solicitações esteja muito alto pode ocorrer o atraso da sua proposta.
    `,
  },
  {
    title: 'Quanto tempo leva para o valor cair na conta?',
    text: `
      Se estiver tudo certo com sua análise de crédito e seu pedido de empréstimo for aprovado, o valor é depositado em até 1 dia útil na conta bancária informada.
    `,
  },
  {
    title: 'Quais as formas de pagamento?',
    text: `
      Atualmente as formas de pagamento são boleto bancário, PIX e Cartão de Crédito. Mensalmente a NoVerde envia um lembrete para o seu e-mail cadastrado com um link para você baixar o seu boleto. Mas você também pode ver seus boletos em qualquer momento direto no aplicativo ou pelo site da NoVerde.
    `,
  },
  {
    title: 'Posso adiantar parcelas do empréstimo?',
    text: `
      Você pode fazer pagamentos antecipados a qualquer momento. Para fazer pagamentos antecipados, entre em contato com a central de atendimento da NoVerde para conseguir o link de pagamento.
      <br />
      Central de atendimento da NoVerde: (11) 4020-1583 - De segunda a sexta, das 09h às 20h, exceto feriados.
    `,
  },
  {
    title: 'O que acontece se não pagar uma parcela?',
    text: `
      Não pagar a parcela de seu empréstimo não é legal, mas entendemos que imprevistos acontecem.
      <br />
      Dessa forma você vai acabar pagando multa de 2%, juros adicionais de 1% ao mês (juros moratórios) e corre o risco de sofrer protestos e ter seu nome inscrito nos órgãos de proteção ao crédito, tais como Serasa, SCPC ou Boa Vista.
      <br />
      Importante saber que mesmo que você avise a NoVerde que realizará o pagamento em atraso, eles não têm como impedir que as diversas formas de cobrança ocorram, como por e-mail, telefone e SMS por exemplo.
    `,
  },
]
